import React from "react";
import { Box, Typography } from "@mui/material";

const StatusLegends = () => {
  const legendData = [
    { label: "Correct", color: "#4CAF50" }, // Green
    { label: "Incorrect", color: "#F44336" }, // Red
    { label: "Not answered", color: "#8898AA" }, // Gray
  ];

  return (
    <Box display="flex" gap={2} sx={{ padding: "10px 0px" }}>
      {legendData.map((item) => (
        <Box key={item.label} display="flex" alignItems="center" gap={1}>
          <Box
            sx={{
              width: 12,
              height: 12,
              borderRadius: "50%",
              backgroundColor: item.color,
            }}
          />
          <Typography
            variant="body2"
            color="textSecondary"
            sx={{ fontSize: "13px" }}
          >
            {item.label}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};

export default StatusLegends;
